import React, { ReactNode } from "react"

import "@/styles/component/card.scss"

type Props = {
  children: ReactNode
}
const Card: React.FC<Props> = ({ children }) => (
  <div className="card">
    {children}
  </div>
)

export default Card
